export default "__VITE_ASSET__DJtGB6_b__"